import { ILinkPreviewModel } from '@gem/models/commonModel';

import Entities from 'STORE';

export function getLinkPreview(groupId: string): ILinkPreviewModel | null {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);

  if (!inputPanel || inputPanel.linkPreviewCancelled) {
    return null;
  }

  return inputPanel.linkPreviews.get(inputPanel.link) || null;
}
